import React, { useState, useRef, useMemo, useEffect } from "react";
// import axios from "axios";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
import Box from "@mui/material/Box";
// import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Card, Divider, Icon, LinearProgress } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setRouteCurrentPacket } from "features/routeReplay/routeReplaySlice";
import {
  setSelectedJourneyPlotData,
} from "features/routeReplay/routeReplaySlice";

// import { fetchJourneyData } from "features/routeReplay/routeReplayThunk";
const HistoryCard = () => {
  const devices = useSelector((state) => state.routeReplay.devices);
  // const routeData = useSelector((state) => state.routeReplay);
  const journeyData = useSelector((state) => state.routeReplay.journey);
  // const journeyPlot = useSelector((state) => state.routeReplay.journeyPlot);

  const [progress, setProgress] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  // const [journey, setJourney] = useState([]);
  const [selectedJourney, setSelectedJourney] = useState(null);
  const intervalRef = useRef(null);
  const dispatch = useDispatch();

  const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return "00 Hr : 00 Min ";
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    // const secs = Math.floor(seconds % 60);
    return `${hrs.toString().padStart(2, "0")} Hr : ${mins
      .toString()
      .padStart(2, "0")} Min `;
  };

  const devicePackets = useMemo(() => {
    if (!devices || !devices.devices) return [];
    return Object.entries(devices.devices)
      .filter(([key]) => !isNaN(key))
      .map(([timestamp, data]) => ({
        timestamp: Number(timestamp),
        ...data,
      }))
      .sort((a, b) => a.timestamp - b.timestamp);
  }, [devices]);
  const currentPacket = devicePackets[progress] || {};

  useEffect(() => {
    dispatch(setRouteCurrentPacket(currentPacket));
  }, [progress]);
  const packet = devicePackets[progress] || {};

  console.log("🚀 ~ file: historyCard.js:75 ~ HistoryCard ~ packet:", packet);

  const handlePlay = () => {
    if (isPlaying) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setIsPlaying(false);
    } else {
      setIsPlaying(true);
      intervalRef.current = setInterval(() => {
        setProgress((prev) => {
          if (prev >= devicePackets.length - 1) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            setIsPlaying(false);
            return prev;
          }
          return prev + 1;
        });
      }, 200);
    }
  };

  const handleChange = (event) => {
    const selectedSelector = event.target.value;
    const journey = journeyData.find((j) => j.journeyId === selectedSelector);
    dispatch(setSelectedJourneyPlotData(journey));
    setSelectedJourney(journey);
  };
  return devicePackets.length > 0 ? (
    <MDBox p={1} sx={{ paddingTop: "0px" }}>
      <Card
        sx={{
          padding: "0 16px 16px 16px",
          borderRadius: 3,
          boxShadow: "none",
        }}
      >
        <>
          <MDBox mb={2}>
            <input
              type="range"
              min="0"
              max={devicePackets.length - 1}
              value={progress}
              onChange={(e) => {
                const val = Number(e.target.value);
                setProgress(val);
              }}
              style={{
                width: "100%",
                height: "8px",
                borderRadius: "4px",
                outline: "none",
                cursor: "pointer",
              }}
            />
          </MDBox>

          <MDBox mb={2}>
            <MDButton
              fullWidth
              variant="outlined"
              color="info"
              onClick={handlePlay}
              startIcon={<Icon>{isPlaying ? "pause" : "play_arrow"}</Icon>}
            >
              {isPlaying ? "Pause" : "Play"}
            </MDButton>
          </MDBox>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <Select
                value={selectedJourney?.journeyId || ""}
                onChange={handleChange}
                displayEmpty
                padding="2px"
                renderValue={(selected) => {
                  if (!selected) {
                    return (
                      <Box sx={{ px: 1.5, py: 0.5, p: 1, color: "text.secondary" }}>
                        Select and plot Journey
                      </Box>
                    );
                  }

                  const journey = journeyData.find(
                    (j) => j.journeyId === selected
                  );
                  if (!journey)
                    return (
                      <Box sx={{ px: 1.5, py: 0.5, color: "text.secondary" }}>
                        Select Journey & plot
                      </Box>
                    );

                  const match = journey.selector.match(
                    /(ROUTE\s*\d+)\s+(\w+).*?\((\d{2}:\d{2})-(\d{2}:\d{2})\)/
                  );

                  const route = match ? match[1] : journey.selector;
                  const type = match ? match[2] : "";
                  const startTime = match ? match[3] : "";

                  return `${route} ${type} - ${startTime}`;
                }}
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #ebe9e6",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #ebe9e6",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #ebe9e6",
                  },
                }}
              >
                {journeyData.map((journey) => {
                  const match = journey.selector.match(
                    /(ROUTE\s*\d+)\s+(\w+).*?\((\d{2}:\d{2})-(\d{2}:\d{2})\)/
                  );

                  const route = match ? match[1] : journey.selector;
                  const type = match ? match[2] : "";
                  const startTime = match ? match[3] : "";

                  return (
                    <MenuItem key={journey.journeyId} value={journey.journeyId}>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <strong>{route}</strong>
                        <span>
                          {type} - <strong>{startTime}</strong>
                        </span>
                      </div>
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>

          <Divider sx={{ my: 2 }} />

          <MDBox>
            <MDBox display="flex" justifyContent="space-between" mb={1}>
              <MDTypography variant="body2" color="text">
                Time
              </MDTypography>
              {/* <MDTypography variant="body2" fontWeight="medium" color="text">
                {new Date(currentPacket.timestamp).toLocaleString("en-GB")}
              </MDTypography> */}
              <MDTypography
                variant="body2"
                fontWeight="medium"
                sx={{ color: currentPacket.raw.isMissing === "true" ? "red" : "text" }}
              >
                {new Date(currentPacket.timestamp).toLocaleString("en-GB")}
              </MDTypography>
            </MDBox>

            <MDBox
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 1.5,
                borderRadius: 2,
                mb: 2,
                background: "#f9f9f9",
              }}
            >
              <MDTypography variant="body2" fontWeight="medium">
                Ignition
              </MDTypography>
              <MDTypography
                variant="body2"
                fontWeight="bold"
                color={
                  packet.raw?.IGNITION === "1" ? "success.main" : "error.main"
                }
              >
                {packet.raw?.IGNITION === "1" ? "ON" : "OFF"}
              </MDTypography>
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="body2" color="textSecondary" mb={1}>
                Signal Strength
              </MDTypography>
              <Box
                sx={{
                  width: "100%",
                  height: 8,
                  backgroundColor: "#e0e0e0",
                  borderRadius: 5,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: `${Math.min(Math.max(parseFloat(packet?.raw?.SIGNAL_STRENGTH) || 0, 0), 100)}%`,
                    height: "100%",
                    backgroundColor: "#49a3f1",
                    transition: "width 0.3s ease",
                  }}
                />
              </Box>
              <MDTypography variant="caption" color="textSecondary">
                {(parseFloat(packet?.raw?.SIGNAL_STRENGTH) || 0).toFixed(2)}%
              </MDTypography>
            </MDBox>

            <MDBox display="flex" justifyContent="space-between" mb={1}>
              <MDTypography variant="body2" color="textSecondary">
                Satellites
              </MDTypography>
              <MDTypography
                variant="body2"
                fontWeight="medium"
                color="info.main"
              >
                {packet.raw?.TOTAL_SATELLITE}
              </MDTypography>
            </MDBox>

            <MDBox display="grid" gridTemplateColumns="1fr 1fr" gap={2} mb={2}>
              <MDBox
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  p: 1.5,
                  textAlign: "center",
                }}
              >
                <MDTypography variant="h6" fontWeight="bold" color="info.main">
                  {Math.round(packet.speed) || 0} km/hr
                </MDTypography>
                <MDTypography variant="caption" color="textSecondary">
                  Current Speed
                </MDTypography>
              </MDBox>

              <MDBox
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 2,
                  p: 1.5,
                  textAlign: "center",
                }}
              >
                <MDTypography variant="h6" fontWeight="bold" color="info.main">
                  {Math.round(devices?.maxSpeed?.toFixed(2) * 3.6 || 0)} km/hr
                </MDTypography>
                <MDTypography variant="caption" color="textSecondary">
                  Max Speed
                </MDTypography>
              </MDBox>
            </MDBox>

            <Divider sx={{ my: 2 }} />
            <MDTypography
              variant="subtitle2"
              fontWeight="bold"
              color="textSecondary"
              mb={1}
            >
              ⏱ Time Analysis
            </MDTypography>

            <MDBox display="flex" justifyContent="space-between" mb={1}>
              <MDTypography variant="body2" color="textSecondary">
                Total Time
              </MDTypography>
              <MDTypography
                variant="body2"
                fontWeight="medium"
                color="info.main"
              >
                {formatDuration(devices?.activeDuration)}
              </MDTypography>
            </MDBox>

            <MDBox display="flex" justifyContent="space-between" mb={1}>
              <MDTypography variant="body2" color="textSecondary">
                Running Time
              </MDTypography>
              <MDTypography
                variant="body2"
                fontWeight="medium"
                color="info.main"
              >
                {formatDuration(devices?.runningTime)}
              </MDTypography>
            </MDBox>

            <MDBox display="flex" justifyContent="space-between" mb={1}>
              <MDTypography variant="body2" color="textSecondary">
                Idle Time
              </MDTypography>
              <MDTypography
                variant="body2"
                fontWeight="medium"
                color="info.main"
              >
                {formatDuration(devices?.idleTime)}
              </MDTypography>
            </MDBox>

            <MDBox display="flex" justifyContent="space-between" mb={1}>
              <MDTypography variant="body2" color="textSecondary">
                Total Distance
              </MDTypography>
              <MDTypography
                variant="body2"
                fontWeight="medium"
                color="info.main"
              >
                {(devices?.distanceTravelled / 1000).toFixed(2)} Km
              </MDTypography>
            </MDBox>


          </MDBox>
        </>
      </Card>
    </MDBox>
  ) : null;
};

export default HistoryCard;
